export const ROLES = {
  ADMIN: 'ADMIN',         // SIRI superbruger
  SC_ADMIN: 'SC_ADMIN',   // Sprogcenter administrator
  CENSOR: 'CENSOR',      // Censor
  TEACHER: 'TEACHER'     // Underviser
};